import { unwrapResult } from '@reduxjs/toolkit';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Switch, Text } from '@rsos/components/capstone/base';
import {
  ACTIVE,
  DEACTIVATED,
  APPEAR_ONLINE,
  APPEAR_OFFLINE,
} from '@rsos/constants/peerAgenciesStatuses';
import {
  toggleAgencyStatus,
  updateAgency,
} from '@rsos/reduxDataStore/src/features/peerAgencies/peerAgenciesSlice';
import { notifyError } from '@rsos/utils/toastUtils';

const AgencyStatusToggle = ({ agency }) => {
  const dispatch = useDispatch();
  const { sinatra } = useSelector(state => state);
  const org = sinatra.user.currentOrg.name;
  const { error } = useSelector(state => state.peerAgencies);
  const { id, status } = agency;

  const toggleSwitch = () => {
    const data = {
      org,
      id,
      status: status === ACTIVE ? DEACTIVATED : ACTIVE,
    };
    dispatch(updateAgency(data))
      .then(unwrapResult)
      .then(response => {
        const { id, status } = response;
        if (id && status) dispatch(toggleAgencyStatus({ id, status }));
      })
      .catch(() => {
        if (error?.data?.detail) notifyError(error.data.detail);
        else notifyError(error);
      });
  };

  return (
    <Box horizontal align="center">
      <>
        <Switch isOn={status === ACTIVE} onClick={() => toggleSwitch()} />
        <Text
          color={status === ACTIVE ? 'success' : 'secondaryText'}
          data-name="agency-status"
          ml="7px"
          size="normal"
        >
          {status === ACTIVE ? APPEAR_ONLINE : APPEAR_OFFLINE}
        </Text>
      </>
    </Box>
  );
};

export default AgencyStatusToggle;
